module.exports = __webpack_public_path__ + "img/cs-basicEduS-1.a7910ec6.jpg";